import {
    type FC
} from "react";
import {
    Platform
} from "react-native";
import type IAlertTitleProps from "./type";
import stylesheet, {
    ALERT_TITLE_VARIANT
} from "./stylesheet";
import type {
    AlertPartContentProps
} from "../../type";
import {
    withAlertContext
} from "../../context";
import Text from "../../../text";

const AlertTitleContent: FC<AlertPartContentProps<IAlertTitleProps>> = ({
    customTheme: customThemeProp,
    headingLevel,
    children,
    context,
    style,
    ...props
}) => {
    const headingProps = headingLevel && Platform.OS === "web" ? {
        "aria-level": headingLevel
    } : {};

    return <Text
        {...headingProps}
        {...props}
        style={[
            style,
            stylesheet.title,
            context.isCompact ? stylesheet.compact : undefined
        ]}
        customTheme={customThemeProp ?? context.customTheme}
        customColor={context.currentColors.titleColor}
        role={headingLevel ? "heading" : props.role}
        variant={ALERT_TITLE_VARIANT}
    >
        {children}
    </Text>;
};
export default withAlertContext("title", AlertTitleContent);
